import FormComponent from "../components/FormComponent";

function Banner(props) {
  return (
    <section id="banner" className="position-relative">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 p-0">
            <h1>
              New beginnings deserve <br /> the right Home Loan
            </h1>
            {/* <h5>
              <em>
                *T&Cs Apply. Nil pre-payment charges are applicable for loan
                with floating rate of interest.
              </em>
            </h5> */}
            <img
              src="dist/img/ak_mob.webp"
              rel="preload"
              width={568}
              height={547}
              alt="Banner Home Loan"
              className="img-fluid sam_mob d-lg-none"
            />
            <div className="d-flex width_inherit">
              <div className="feat">
                <div className="d-lg-flex align-items-center gap-2">
                  <div className="iconwrap">
                    <img
                      src="dist/img/icons/icon01.svg"
                      alt="interest rates"
                      width={30}
                      height={30}
                    />
                  </div>
                  <p>
                    Attractive <br />
                    interest rates
                  </p>
                </div>
                <div className="d-lg-flex align-items-center gap-2">
                  <div className="iconwrap">
                    <img
                      src="dist/img/icons/icon02.svg"
                      alt="Home Loan"
                      width={30}
                      height={30}
                    />
                  </div>
                  <p>
                    Quick <br /> processing
                  </p>
                </div>
                <div className="d-lg-flex align-items-center gap-2">
                  <div className="iconwrap">
                    <img
                      src="dist/img/nil_foreclosure.svg"
                      alt="Nil foreclosure"
                      width={26}
                      height={30}
                    />
                  </div>
                  <p>
                    Nil Pre-payment
                    <br />
                    Charges*
                  </p>
                </div>
              </div>
              <img
                src="dist/img/ak_desk.webp"
                rel="preload"
                width={507}
                height={481}
                alt="Banner Home Loan"
                className="img-fluid samantha_desk d-none d-lg-block"
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-4">
            <FormComponent />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
